export default __webpack_public_path__ + "e2efef5bac1a80af3677f1f852ab38bc.png";